import {ChangeDetectorRef, Component, ViewChild} from '@angular/core';
import {
  Alert,
  AlertController,
  Content,
  IonicPage,
  Loading,
  LoadingController,
  NavController,
  NavParams,
  Platform,
  Popover,
  PopoverController,
  Range, TextInput
} from 'ionic-angular';
import {TranslateService} from "@ngx-translate/core";
import {VizixService} from "../../providers/vizix.service";
import {ReaderService} from "../../providers/reader.service";
import {
  CONFIGURATION_ERROR,
  INVALID_FORMAT,
  NAV_PARAM_AUTO_SEARCH,
  NAV_PARAM_RETURN_PAGE,
  NOT_FOUND,
  READER_MODE_INVENTORY,
  READER_TYPE_BARCODE,
  RETURN_PAGE_LOOK_UP,
  SERVER_ERROR,
  TAG_INFORMATION_SOURCE_LOOK_UP,
  UNKNOWN_ERROR, VALIDATION_INPUT_TAG
} from "../../app/app.constants";
import {AppConfigPage} from "../app-config/app-config";
import {TagReadBarcodeResponse} from "../../models/reader-model/tagReadBarcodeResponse";
import {DeviceSelectPage} from "../device-select/device-select";
import {PopoverDetailsPage} from "../popover-details/popover-details";
import {ReportDefinitionResponse} from 'vizixc/dist';
import {TableScriptReportResponse} from '../../models/TableScriptReportResponse';
import {FindItemPage} from '../find-item/find-item';
import {LookupConstants} from './lookup.constants';
import {ConfigurationThing} from '../../models/configurationThing';
import {ErrorResponse} from "../../models/ErrorResponse";
import {Device} from '@ionic-native/device';
import {ReportFilter} from 'vizixc/dist/interfaces/report.filter.interface';
import {TagInformationService} from "../../providers/tag.information.service";
import {InsomniaService} from "../../providers/insomnia.service";


@IonicPage()
@Component({
  selector: 'page-look-up',
  templateUrl: 'look-up.html',
  providers: []
})
export class LookUpPage {
  public configurationApp: ConfigurationThing;
  isTriggerPulled: boolean;
  readerPower: number;
  searchInputText: string;
  isFindItemScreenShowing: boolean;
  isCameraEnabled: boolean;
  filtersLoaded: boolean = false;
  filteredItem: Array<string> = [];
  sizeQuantities: any = {};
  finalResult = {};
  notFilteredColumnNames: Array<any> = [];
  columnNames: Array<any> = [];
  shapes: {};
  OVAL: string = LookupConstants.SHAPE_OVAL;
  SQUARE: string = LookupConstants.SHAPE_SQUARE;
  quantities = {};

  private isAlertShowing: boolean;
  private alertOkCancel: Alert;
  private alertOk: Alert;
  private alertError: Alert;
  private alertReaderNotConnectedError: Alert;
  private alertNoInformationFoundError: Alert;
  private alertInvalidFormatError: Alert;
  private alertConfigurationError: Alert;
  private alertReaderError: Alert;
  private alertServerError: Alert;
  private loading: Loading;
  private barcodeDeviceSubscribe;
  private barcodeReaderSubscribe;
  private popoverDetails: Popover;
  private properties: any;
  private items: any;
  private isPopPageActive = false;
  private isIpodSpecial: boolean;
  private isFirstResultEmpty: boolean = false;
  private upcFilterLabel: string;
  private filterLabelStoreId: string;
  private defaultPropertyFilterLabel: string;
  private storeId: number;
  private qtyIndex: number = 0;
  private allItemsEmpty: boolean = false;
  private isIosVersionLessThan11: boolean = false;

  public source: string = TAG_INFORMATION_SOURCE_LOOK_UP;


  @ViewChild('rangePower') rangeBarReaderPower: Range;
  @ViewChild(Content) content: Content;
  @ViewChild('searchInput') inputTagField: TextInput;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public translate: TranslateService,
              private vizixService: VizixService,
              private readerService: ReaderService,
              private _alertCtrl: AlertController,
              private _loadingCtrl: LoadingController,
              private cdr: ChangeDetectorRef,
              private platform: Platform,
              private _popoverCtrl: PopoverController,
              private deviceInfo: Device,
              private _insomniaService: InsomniaService,
              private tagInformationService: TagInformationService) {
    if (this.deviceInfo) {
      this.isIpodSpecial = this.deviceInfo.model ? this.deviceInfo.model === 'iPod7,1' && this.deviceInfo.version === '11.1.2' : false;
    }
    /*Initialization*/
    this.isTriggerPulled = false;
    this.readerPower = 100;
    this.isAlertShowing = false;
    this.searchInputText = "";
    this.isFindItemScreenShowing = false;
    this.storeId = this.vizixService.getStoreId();
    this.upcFilterLabel = this.vizixService.configurationApp.LookupConfiguration.UPCFilterLabel.value || LookupConstants.UPC;
    this.filterLabelStoreId = this.vizixService.configurationApp.LookupConfiguration.FilterLabelStoreID.value || LookupConstants.STORE_ID;
    this.defaultPropertyFilterLabel = this.vizixService.configurationApp.LookupConfiguration.DefaultPropertyFilterLabel.value || LookupConstants.STYLE;

    /*MockUp of characteristics of product*/
    this.properties = {};
    /*MockUp of Items*/
    this.items = {};

    this.askPlatformOs();

    // Init Back button
    this.platform.ready().then((readySource) => {
      this.platform.registerBackButtonAction(() => {
        this.goBack();
      });
    });
  }


  //Ask OS and Ios version
  askPlatformOs() {
    this.platform.ready().then(() => {
      if (this.platform.is('android')) {
        this.isIosVersionLessThan11 = false;
      } else if (this.platform.is('ios')) {
        const osVersionNumber = this.platform.version().num;
        this.isIosVersionLessThan11 = osVersionNumber < 11;
      } else if (this.platform.is('mobileweb')) {
        this.isIosVersionLessThan11 = false;
      } else {
        this.isIosVersionLessThan11 = false;
      }
    });
  }

  ionViewDidLoad() {

    //insomnia service with the method insomniaKeepAwakeScreen() will Prevent the screen of the mobile device from falling asleep. (Only in this screen)
    this._insomniaService.insomniaKeepAwakeScreen().subscribe(
      (response: any) => {
        console.log('[INSOMNIA PLUGIN]', response);
      }, (error) => {
        console.error('[INSOMNIA PLUGIN]', 'Error Keeping application awake');
      }
    );

    this.vizixService.VizixUpdateReportDefinitionIdentifyTag();
  }

  ionViewDidEnter() {

    //insomnia service with the method insomniaKeepAwakeScreen() will Prevent the screen of the mobile device from falling asleep. (Only in this screen)
    this._insomniaService.insomniaKeepAwakeScreen().subscribe(
      (response: any) => {
        console.log('[INSOMNIA PLUGIN]', response);
      }, (error) => {
        console.error('[INSOMNIA PLUGIN]', 'Error Keeping application awake');
      }
    );

    this.ChangeModeReader(READER_TYPE_BARCODE);
    this.cdr.reattach();
    this.cdr.detectChanges();

    this.platform.registerBackButtonAction(() => {
      this.goBack();
    });
  }

  ionViewWillEnter() {
  }

  /**
   * Lifecycle
   */
  ionViewWillLeave() {

    //insomnia service with the method insomniaAllowScreenSleepAgain will screen sleep again when go to other page
    this._insomniaService.insomniaAllowScreenSleepAgain().subscribe(
      (response: any) => {
        console.log('[INSOMNIA PLUGIN]', response);
      }, (error) => {
        console.error('[INSOMNIA PLUGIN]', 'Error allowing appliccation sleep again');
      }
    );

    this.UnsubscribeMethodsReaderService();
    this.stopReader();
    this.cdr.detach();
  }


  /**
   * Look up tag will call the necessary report
   * @param {string} tag
   */
  lookUpTag(tag: string) {
    this.searchInputText = tag.toUpperCase().trim();
    if (this.searchInputText && this.searchInputText.length) {
      this.dismissAlertsLoadings();
      this.showLoading();
      this.tagInformationService.setTag(tag, this.source, this.upcFilterLabel);
    }
  }

  /**
   * Fin tag in Vizix
   * @param {string} upc
   */
  findTagInVizix(upc: string) {
    // Call look up report definition report or report execution.
    this.vizixService.VizixGetReportDefinitionLookup().subscribe((dataReportDefinition: ReportDefinitionResponse) => {
      // Get report filters
      const reportFilters: Array<ReportFilter> = dataReportDefinition.getReportFilter();

      //Get editable filters
      const reportFiltersEditables: Array<ReportFilter> = reportFilters.filter((val) => val.editable);

      //Get filters except serial and style
      const showFilters: Array<ReportFilter> = reportFiltersEditables.filter((val) => val.propertyName !== LookupConstants.SERIAL && val.propertyName !== this.defaultPropertyFilterLabel).sort((a, b) => a.displayOrder - b.displayOrder);

      //Get the UPC from the response
      // let itemAux = this.tagInformationResponse.find((val: FieldItem) => val.label === LookupConstants.SERIAL || val.label === this.upcFilterLabel);
      // let upc = itemAux ? itemAux.value : '';

      // Build body from request based on lookup configuration
      let body = {};
      body[this.upcFilterLabel] = upc;

      // Adding store id to request body
      body[this.filterLabelStoreId] = this.storeId;

      //Call report execution for look up (Table script )
      this.vizixService.VizixPostReportExecutionLookUp(body).subscribe((resultLookupTableScript: TableScriptReportResponse) => {
        console.log("resultLookupTableScript", resultLookupTableScript);

        // Store reference to this in self variable to use it later
        let self = this;
        // Results of table scripts
        const results: Array<Array<string>> = resultLookupTableScript.data;

        // Get the column names of the filters we want show
        const columnNames: Array<string> = showFilters.map(val => val.label);

        // Get every column name from response
        this.notFilteredColumnNames = resultLookupTableScript.columnNames.slice(0, 3).concat(columnNames);

        this.qtyIndex = this.findIndexByProperty(this.notFilteredColumnNames, LookupConstants.QTY) > -1 ? this.findIndexByProperty(this.notFilteredColumnNames, LookupConstants.QTY) : 1;

        this.isFirstResultEmpty = results[0][this.qtyIndex] == '0';

        this.allItemsEmpty = this.checkNoItemsFound(results, this.qtyIndex);

        // Get the shapes from every filter to show in the view (Currently we support OVAL and SQUARE)
        this.shapes = this.getShapesFromShowFilters(showFilters);
        // Init an object that will contain all the data in its properties
        let finalResult = this.initFinalResult(columnNames);

        // Array used to filter the results from the table script report since we only need the values that we are going to show
        let filterResults: Array<Array<string>> = this.filterResults(results, columnNames, resultLookupTableScript.columnNames);

        //Iterate over the results in order to get another array with the unique value of each property
        filterResults.forEach((result) => {
          result.forEach((val, index) => {
            if (finalResult[columnNames[index]]) {
              finalResult[columnNames[index]].add(val);
            }
          })
        });
        Object.keys(finalResult).forEach(function (key, index) {
          finalResult[key] = Array.from(finalResult[key]);
          self.properties[key] = finalResult[key].map((val, i) => new ItemFiler(val, i === 0, false));
        });

        this.finalResult = finalResult;
        this.columnNames = columnNames;

        // Get the quantity from the first filter
        this.quantities = this.initQuantities(results, columnNames, this.finalResult, this.notFilteredColumnNames);

        let item = filterResults[0];
        this.items = results;
        this.filteredItem = this.filterUpc(item);

        // Check if the quantity of the selected item is 0 (This will not happen in real life since the use case involves an item scanned via barcode, therefore the product will always exist)
        if (this.filteredItem[this.qtyIndex] == '0') {
          this.handleElementsIfQtyIsEmpty(self, this.properties);
        }

        this.filtersLoaded = true;
        this.isFindItemScreenShowing = true;
        this.dismissAlertsLoadings();
        this.content.resize();
        //Get unique values of each propery to build the filters  v
      }, (errLookUp) => {
        this.dismissAlertsLoadings();
        console.log("errLookUp", errLookUp);
        this.ShowAlertServerError();
      });

    }, (error: ErrorResponse) => {
      this.showErrorAlert(error);
    });
  }

  /**
   * showErrorAlert
   * @param {ErrorResponse} error
   */
  showErrorAlert(error: ErrorResponse) {
    this.dismissAlertsLoadings();
    console.log('Showing error', error);
    if (error.errorCode != null) {
      if (error.errorCode === NOT_FOUND) {
        this.ShowAlertNoInformationFound();
        this.clearInput(false);
      } else if (error.errorCode === INVALID_FORMAT) {
        this.ShowAlertInvalidFormatError();
        this.clearInput(true);
      } else if (error.errorCode === SERVER_ERROR) {
        this.ShowAlertServerError();
        this.clearInput(true);
      } else if (error.errorCode === UNKNOWN_ERROR) {
        this.ShowAlertError(this.translate.instant('find_item.alerts.unknown_error.title'),
          this.translate.instant('find_item.alerts.unknown_error.message'), this.translate.instant('find_item.alerts.unknown_error.ok'));
        this.clearInput(true);
      } else if (error.errorCode === CONFIGURATION_ERROR) {
        this.ShowAlertConfigurationError();
        this.clearInput(true);
      }
    } else {
      this.ShowAlertServerError();
      this.clearInput(true);
    }
    this.isAlertShowing = true;
  }

  onFieldValueFound(value) {
    this.findTagInVizix(value);
  }

  onError(error) {
    this.showErrorAlert(error);
  }


  private UnsubscribeMethodsReaderService() {
    if (this.barcodeDeviceSubscribe) {
      this.barcodeDeviceSubscribe.unsubscribe();
    }
    if (this.barcodeReaderSubscribe) {
      this.barcodeReaderSubscribe.unsubscribe();
    }
  }

  /**
   * Sets reader power
   */
  setReaderPower() {
    this.isReaderConnected(true).then(() => {
      this.readerService.setReaderPower(this.readerPower, READER_MODE_INVENTORY).subscribe(
        (response: any) => {
          console.log('Set Reader Power Response', response);
        }, (error) => {
          console.log('ERROR', error);
        }
      );
    });
  }

  /**
   * Called every time we do a reader operation
   * @param {boolean} showError
   * @returns {Promise<boolean>}
   */
  isReaderConnected(showError: boolean): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.readerService.isConnected().subscribe(
        (result) => {
          if (result) {
            resolve(true); // Connected
          } else {
            this.rangeBarReaderPower.disabled = true;
            console.error("Reader not connected"); // Not connected
            resolve(false);
          }
        },
        (error) => {
          console.error("Reader not connected", error);
          this.dismissAlertsLoadings();
          resolve(false);
        }
      );
    });
  }

  /**
   * dismiss all the popups and loadings
   */
  private dismissAlertsLoadings() {
    if (this.popoverDetails) {
      this.popoverDetails.dismiss();
      this.popoverDetails = null;
    }
    if (this.alertOk) {
      this.alertOk.dismiss();
      this.alertOk = null;
    }
    if (this.alertError) {
      this.alertError.dismiss();
      this.alertError = null;
    }
    if (this.alertOkCancel) {
      this.alertOkCancel.dismiss();
      this.alertOkCancel = null;
    }
    if (this.alertReaderNotConnectedError) {
      this.alertReaderNotConnectedError.dismiss();
      this.alertReaderNotConnectedError = null;
    }
    if (this.alertReaderError) {
      this.alertReaderError.dismiss();
      this.alertReaderError = null;
    }
    if (this.alertConfigurationError) {
      this.alertConfigurationError.dismiss();
      this.alertConfigurationError = null;
    }
    if (this.alertInvalidFormatError) {
      this.alertInvalidFormatError.dismiss();
      this.alertInvalidFormatError = null;
    }
    if (this.alertServerError) {
      this.alertServerError.dismiss();
      this.alertServerError = null;
    }
    if (this.alertNoInformationFoundError) {
      this.alertNoInformationFoundError.dismiss();
      this.alertNoInformationFoundError = null;
    }
    if (this.loading) {
      this.loading.dismiss();
      this.isAlertShowing = false;
    }
  }


  /**
   * ShowAlertOkCancel
   * @param {string} title
   * @param {string} messageText
   * @param {string} okText
   * @param {() => void} callbackOk
   * @param {string} cancelText
   * @param {() => void} callbackCancel
   */
  ShowAlertOkCancel(title: string, messageText: string, okText: string, callbackOk: () => void, cancelText: string, callbackCancel?: () => void) {
    this.alertOkCancel = this._alertCtrl.create({
      title: title,
      message: messageText,
      enableBackdropDismiss: false,
      buttons: [
        {
          text: okText,
          handler: () => {
            this.isAlertShowing = false;
            callbackOk();
            // return false; // to not dismiss the alert
          }
        },
        {
          text: cancelText,
          role: 'cancel',
          handler: () => {

            this.isAlertShowing = false;
            if (callbackCancel) {
              callbackCancel();
            }
          }
        }
      ]
    });
    this.alertOkCancel.present();
    this.isAlertShowing = true;
  }

  /**
   * ShowAlertError
   * @param {string} title
   * @param {string} messageText
   * @param {string} okText
   */
  ShowAlertError(title: string, messageText: string, okText: string) {
    this.alertError = this._alertCtrl.create({
      title: title,
      message: messageText,
      enableBackdropDismiss: false,
      buttons: [
        {
          text: okText,
          role: 'cancel',
          handler: () => {
            this.isAlertShowing = false;
          }
        }
      ]
    });

    this.alertError.present();
    this.isAlertShowing = true;
  }

  /**
   * ShowAlertOk
   * @param {string} title
   * @param {string} messageText
   * @param {string} okText
   * @param {() => void} callbackOk
   */
  ShowAlertOk(title: string, messageText: string, okText: string, callbackOk?: () => void) {
    this.alertOk = this._alertCtrl.create({
      title: title,
      message: messageText,
      enableBackdropDismiss: false,
      buttons: [
        {
          text: okText,
          handler: () => {
            this.isAlertShowing = false;
            if (callbackOk) {
              callbackOk();
            }
          }
        }
      ]
    });

    this.alertOk.present();
    this.isAlertShowing = true;
  }

  /**
   * Alert that shows when the reader is not connected and user tries to do something in the module
   */
  ShowAlertReaderNotConnected() {
    this.alertReaderNotConnectedError = this._alertCtrl.create({
      title: this.translate.instant('menu_tracker_retail.alerts.error_pair.title'),
      message: this.translate.instant('menu_tracker_retail.alerts.error_pair.message'),
      buttons: [
        {
          text: this.translate.instant('menu_tracker_retail.alerts.error_pair.cancel'),
          role: 'cancel',
          handler: () => {
            this.goBack();
            this.isAlertShowing = false;
          }
        },
        {
          text: this.translate.instant('menu_tracker_retail.alerts.error_pair.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.navCtrl.popToRoot().then(() => { // To prevent the page stack to increase every time
              this.navCtrl.push(DeviceSelectPage);
            });
          }
        }
      ]
    });

    this.alertReaderNotConnectedError.present();
    this.isAlertShowing = true;
  }

  /**
   * Show alerts related to no information found errors
   */
  ShowAlertNoInformationFound() {
    // Alert that shows when no information is found for the input tag
    this.alertNoInformationFoundError = this._alertCtrl.create({
      title: this.translate.instant('find_item.alerts.no_information.title'),
      message: this.translate.instant('find_item.alerts.no_information.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('find_item.alerts.no_information.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.clearInput(false);
          }
        }
      ]
    });

    this.alertNoInformationFoundError.present();
    this.isAlertShowing = true;
  }

  /**
   * Show alert related to invalid format errors
   */
  ShowAlertInvalidFormatError() {
    // Alert that shows when there is an error uploading CycleCount
    this.alertInvalidFormatError = this._alertCtrl.create({
      title: this.translate.instant('find_item.alerts.invalid_format.title'),
      message: this.translate.instant('find_item.alerts.invalid_format.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('find_item.alerts.invalid_format.ok'),
          handler: () => {
            this.isAlertShowing = false;
            // this.dismissAll();
            this.clearInput(true);
          }
        }
      ]
    });

    this.alertInvalidFormatError.present();
    this.isAlertShowing = true;
  }

  /**
   * Show alerts related to reader errors
   */
  ShowAlertReaderError() {
    // Alert that shows when there is an error uploading CycleCount
    this.alertReaderError = this._alertCtrl.create({
      title: this.translate.instant('find_item.alerts.reader_error.title'),
      message: this.translate.instant('find_item.alerts.reader_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('find_item.alerts.reader_error.ok'),
          handler: () => {
            this.isAlertShowing = false;
          }
        }
      ]
    });

    this.alertReaderError.present();
    this.isAlertShowing = true;
  }

  /**
   * Show alerts related to configuration errors
   */
  ShowAlertConfigurationError() {
    // Alert that shows when there is an error uploading CycleCount
    this.alertConfigurationError = this._alertCtrl.create({
      title: this.translate.instant('find_item.alerts.configuration_error.title'),
      message: this.translate.instant('find_item.alerts.configuration_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('find_item.alerts.configuration_error.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.clearInput(true);
          }
        }
      ]
    });

    this.alertConfigurationError.present();
    this.isAlertShowing = true;
  }

  /**
   * Shows alert related to server errors
   */
  ShowAlertServerError() {
    this.alertServerError = this._alertCtrl.create({
      title: this.translate.instant('find_item.alerts.server_error.title'),
      message: this.translate.instant('find_item.alerts.server_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('find_item.alerts.server_error.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.clearInput(true);
          }
        }
      ]
    });
    this.alertServerError.present();
    this.isAlertShowing = true;
  }

  /**
   * Go back in the navigation flow
   */
  goBack() {
    if (this.popoverDetails) {
      this.dismissAlertsLoadings();
    } else {
      if (!this.isPopPageActive && !this.isAlertShowing) {
        this.isPopPageActive = true;
        this.navCtrl.pop();
      }
    }
  }

  /**
   * Go to application config page
   */
  goToAppConfig() {
    let returnNavParams = {};
    returnNavParams[NAV_PARAM_RETURN_PAGE] = RETURN_PAGE_LOOK_UP;
    this.navCtrl.push(AppConfigPage, returnNavParams);
  }

  /**
   * Stops reader
   */
  stopReader() {
    this.isReaderConnected(false).then(() => {
      this.readerService.stopScanCC().subscribe(
        (response: any) => {
          console.log('Stop scan response', response);
        }, (error) => {
          console.log('ERROR', error);
        }
      );
    });
  }

  /**
   * Open barcode camera
   */
  openBarcodeCamera() {
    this.readerService.initBarcodeCameraScan().then((barcode) => {
      this.dismissAlertsLoadings();
      this.lookUpTag(barcode.value);
    }, (error) => {
      console.log('Error barcode camera', error);
    });
  }

  /**
   * Clear inputs
   */
  clearInput(clearText?: boolean) {
    if (clearText) {
      this.searchInputText = "";
    }
    this.tagInformationService.reset(this.source);
    this.isFindItemScreenShowing = false;
    this.clearVariables();
    this.ChangeModeReader(READER_TYPE_BARCODE);
    this.content.resize();
  }

  /**
   * Initialize Reader in selected mode
   * @param {string} readerType
   * @constructor
   */
  ChangeModeReader(readerType: string) {
    if (readerType === READER_TYPE_BARCODE) {
      this.changeBarcodeMode();
    } else {
    }
  }

  /**
   * Method that changes configuration to reader barcode and MC barcode
   */
  private changeBarcodeMode() {
    this.barcodeDeviceSubscribe = this.readerService.isDeviceBarcode().subscribe(
      (result) => {
        console.log(result);
        if (result) {
          console.log('Device is barcode enabled');
          this.readerService.initScanDeviceBarcode().subscribe(
            (result: TagReadBarcodeResponse) => {
              if (result.value != null && !this.isAlertShowing) {
                this.clearInput(true);
                this.dismissAlertsLoadings();
                this.lookUpTag(result.value);
              }
            },
            (error) => {
              console.log('Error in device barcode initialization');
              console.log(error);
            }
          );
          this.InitBarcodeMode();
        } else {
          console.log('Device is not barcode enabled');
          console.log("continue without reader", this.readerService.continueWithoutReader);
          this.InitBarcodeMode();
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  /**
   * Init barcode mode
   * @constructor
   */
  private InitBarcodeMode() {
    if (!this.readerService.continueWithoutReader) {
      this.barcodeReaderSubscribe = this.readerService.initBarcodeScan().subscribe(
        (result: TagReadBarcodeResponse) => {
          console.log("result", result);
          if (result.value && !this.isAlertShowing) {
            this.clearInput(true);
            this.lookUpTag(result.value);
          }
        },
        (e) => {
          console.log(e);
          this.dismissAlertsLoadings();
          // this.ShowAlertReaderError();
        }
      );
    }
  }

  /**
   * Show loading dialog
   * @param {string} message
   */
  private showLoading(message?: string) {
    this.loading = this._loadingCtrl.create({
      content: message ? message : 'Please Wait'
    });
    this.dismissAlertsLoadings();
    this.loading.onDidDismiss(() => {
      this.isAlertShowing = false;
    });
    this.loading.present();
    this.isAlertShowing = true;
  }

  /**
   * Open info popover
   */
  openInfo() {
    this.initShowDetailsPopover(this.translate.instant('cycle_count.popovers.details.title'));
  }

  /**
   * Initialize popoverDetails with the new product status list and the current status
   * @param {string} title
   * @param {Array<FieldItem>} fields
   */
  initShowDetailsPopover(title: string) {
    this.dismissAlertsLoadings();

    this.popoverDetails = this._popoverCtrl.create(PopoverDetailsPage,
      {
        title: title,
        tag: this.searchInputText,
        isImageAviable: true,
        showGeigerButton: false,
      }, {showBackdrop: true, cssClass: 'details-popover'});

    this.popoverDetails.present(); // Without event {ev: event}, the popoverDetails shows in the middle
    this.isAlertShowing = true;
    this.popoverDetails.onWillDismiss(() => {
      this.isAlertShowing = false;
      this.popoverDetails = null;
    });
  }

  /**
   * SelectCharacteristic
   * @param {string} group
   * @param {string} valueSelected
   * @constructor
   */
  SelectCharacteristic(group: string, valueSelected: string) {
    let keys: Array<string> = Object.keys(this.properties);
    let indexOfKey = keys.findIndex((value) => value === group);
    let characteristics = this.properties[group];
    characteristics.forEach((val) => val.selected = false);
    for (let characteristic of characteristics) {
      if (characteristic.value === valueSelected) {
        characteristic.selected = !characteristic.selected;
        console.log(characteristic.value);
      }
    }
    keys.forEach((key, index) => {
      if (index > indexOfKey) {
        this.properties[key].forEach((property) => property.selected = false)
      }
    });
    let item: Array<string> = this.getSelectedItemsAndFormItemArray();
    this.filteredItem = this.filterUpc(item, group);
  }

  //TODO Remove console log on production
  /**
   *
   * @param {Array<string>} item
   * @param {string} group
   * @returns {any}
   */
  filterUpc(item: Array<string>, group?: string) {
    let resultsOfFilter: Array<any> = this.items; // Variable to store the filter array every time, currently will be initialized with the items
    let keysProperties = Object.keys(this.properties); // store the keys of the properties
    item.forEach((val, indexArray) => { // iterate over item
      const indexOfColumns = this.notFilteredColumnNames.findIndex((v) => v === keysProperties[indexArray]); // find index of property in column names
      resultsOfFilter = resultsOfFilter.filter((value) => value.find((v, i) => v === val && i === indexOfColumns)); // filter array based on values of array item
      if (resultsOfFilter.length > 0) { // check if result from filter has results
        if (this.properties[keysProperties[indexArray + 1]]) { // check if the selected item has a child from the properties built from report definition
          this.properties[keysProperties[indexArray + 1]].forEach((valueItem: ItemFiler) => { // iterate over the childs
            let disabledFlag = true; // flag to check if item should be disabled
            resultsOfFilter.forEach((l) => {
              if (l.find(v => v === valueItem.value)) {
                disabledFlag = false;
              }
            });
            valueItem.disabled = disabledFlag;
          });
          let indexOfFilter = this.columnNames.findIndex((v) => v === keysProperties[indexArray + 1]);
          let indexOfFilterNotFiltered = this.notFilteredColumnNames.findIndex((v) => v === keysProperties[indexArray + 1]); // we need this index in order to only iterate over the necessary group in case of duplicate values
          // update quantity of group
          this.finalResult[this.columnNames[indexOfFilter]].forEach((val) => {
            this.quantities[keysProperties[indexOfFilter]][val] = resultsOfFilter.filter((result) => result.find((value, i) => value === val && i === indexOfFilterNotFiltered)).reduce((accumulator, currentValue) => {
              return accumulator + parseInt(currentValue[this.qtyIndex]);
            }, 0)
          });

        }
      }
      else {
        keysProperties.forEach((key, index) => {
          if (index > indexArray) {
            this.properties[key].forEach((property) => {
              property.selected = false;
              property.disabled = true;
            })
          }
        })
      }
    });
    if (resultsOfFilter.length > 0) {
      if (group) {
        this.selectDefaultFilters(resultsOfFilter, keysProperties, item, group); // logic to select default filters and update quantities
      }
      return resultsOfFilter[0];
    }

    return resultsOfFilter;
  }

  /**
   * Iterates over the main properties array and returns an array with the items selected according to the display order of the filters
   * @returns {Array<string>}
   */
  getSelectedItemsAndFormItemArray(): Array<string> {
    let arrayResponse = []; // Init empty array to fill after iterating the keys of the main p
    Object.keys(this.properties).forEach((key) => {
      const foundSelected: ItemFiler = this.properties[key].find((val: ItemFiler) => val.selected);
      if (foundSelected) {
        arrayResponse.push(foundSelected.value)
      }
    });
    return arrayResponse;
  }

  /**
   * Selects default items downwards of characteristic selected
   * @param {Array<any>} resultsOfFilter
   * @param {Array<string>} keysProperties
   * @param {Array<string>} item
   * @param {string} group
   */
  selectDefaultFilters(resultsOfFilter: Array<any>, keysProperties: Array<string>, item: Array<string>, group: string) {
    let resultsOfFilterCopy = JSON.parse(JSON.stringify(resultsOfFilter)); // make a copy of results in order to avoid side effects
    const indexProperty = keysProperties.findIndex((val) => val === group);
    const newPropertyArray = keysProperties.slice(indexProperty + 1);
    const recursiveIterator = (filteredResults, item, index) => {
      let c = JSON.parse(JSON.stringify(filteredResults)); // make a copy of results in order to avoid side effects
      if (index < newPropertyArray.length) {
        const val = newPropertyArray[index];
        const indexOfGroup = this.notFilteredColumnNames.findIndex(v => v === val);
        let copy = JSON.parse(JSON.stringify(c));
        this.properties[val].forEach((v) => {
          copy = c.filter((valcopy) => valcopy.find((valueCopyFind, i) => valueCopyFind === v.value && i === indexOfGroup));
          this.updateQuantities(this.quantities[val], v.value, copy, indexOfGroup);
        });
        //Get item to select
        const indexToSelect = this.getItemToSelect(this.quantities[val], this.properties[val]);
        this.properties[val][indexToSelect].selected = true;
        c = c.filter((valcopy) => valcopy.find((valueCopyFind, i) => valueCopyFind === this.properties[val][indexToSelect].value && i === indexOfGroup));
        item.push(this.properties[val][indexToSelect].value);

        this.checkDisabledByGroup(this.properties[val], this.quantities[val]);
        recursiveIterator(c, item, index + 1);
      }
      else {
        this.content.scrollToBottom();
      }
    };
    recursiveIterator(resultsOfFilterCopy, item, 0)
  }

  getItemToSelect(valOfQuantity, properties) {
    let indexResponse = 0;
    let found = false;
    properties.forEach((val, index) => {
      if (valOfQuantity[val.value] > 0 && !found) {
        indexResponse = index;
        found = true;
      }
    });
    return indexResponse
  }

  /**
   * Check items that should be disabled by group, if the quantity is 0 then it should be disabled
   * @param {Array<ItemFiler>} group
   * @param {Array<any>} quantities
   */
  checkDisabledByGroup(group: Array<ItemFiler>, quantities: Array<any>) {
    group.forEach((val: ItemFiler) => {
      val.disabled = quantities[val.value] === 0;
    })
  }

  /**
   * Update quantities of each element when doing auto select
   * @param valOfQuantity
   * @param valueOfNewArray
   * @param resultsOfFilter
   * @param indexOfGroup
   */
  updateQuantities(valOfQuantity, valueOfNewArray, resultsOfFilter, indexOfGroup) {
    valOfQuantity[valueOfNewArray] = resultsOfFilter.filter((valueMain) => valueMain.find((val, index) => val === valueOfNewArray && index === indexOfGroup)).reduce((accumulator, currentValue) => {
      return accumulator + parseInt(currentValue[this.qtyIndex]);
    }, 0);
  }

  /**
   * Returns the filters of found array
   * @param {string} value
   * @returns {any}
   */
  getItemByValue(value: string) {
    const firstItemFound = this.findValueInResults(this.items, value);
    if (firstItemFound) {
      return firstItemFound.slice(3);
    }
    return null;
  }

  /**
   * Gets the item of the results array based on a specific value
   * @param results
   * @param {string} value
   * @returns {any}
   */
  findValueInResults(results, value: string) {
    let filter = results.filter((valueMain) => valueMain.find((val) => val === value));
    if (filter.length > 0) {
      return filter[0];
    }
    else {
      return null;
    }
  }

  /**
   * Go to find Item
   */
  goToFindItem() {
    let returnNavParams = {};
    returnNavParams[NAV_PARAM_RETURN_PAGE] = RETURN_PAGE_LOOK_UP;
    returnNavParams[NAV_PARAM_AUTO_SEARCH] = this.filteredItem[0] || '';
    this.navCtrl.push(FindItemPage, returnNavParams);
  }

  /**
   * Check if all elements from the filters were selected
   * @returns {boolean}
   */
  checkDisabled() {
    let selectedCounter = [];
    Object.keys(this.properties).forEach((val, indexMain) => {
      this.properties[val].forEach((v) => {
        if (v.selected) {
          selectedCounter[indexMain] = true
        }
      })
    });
    return (!(selectedCounter.length === Object.keys(this.properties).length)) || this.allItemsEmpty;
  }

  /**
   * Clear all the elements from first filter downwards (not a pure function)
   */
  cleanSelectedAndDisabledElements(keysProperties, properties) {
    keysProperties.forEach((key, index) => {
      if (index !== 0) {
        properties[key].forEach((property) => {
          property.selected = false;
          property.disabled = true;
        })
      }
      if (index === 0) {
        properties[key].forEach((property) => {
          if (property.disabled) {
            property.disabled = false;
          }
        })
      }
    })
  }

  /**
   * Check if elements of an array are contained in another array
   * @param target
   * @param toMatch
   * @returns {boolean}
   */
  anyMatchInArray(target: Array<any>, toMatch: Array<any>): boolean {
    let found: boolean = true;
    toMatch.forEach((mainValue) => {
      const findValue = target.find((v) => v === mainValue);
      if (!findValue) {
        found = false;
      }
    });
    return found;
  };

  /**
   * Check if there are no items in a two dimensional array based on an specific indec
   * @param {Array<Array<string>>} results
   * @param index
   * @returns {boolean}
   */
  checkNoItemsFound(results: Array<Array<string>>, index): boolean {
    return this.getTotalValuesByIndex(results, index) === 0
  }

  /**
   * Get total values of an two dimension array based on an specific index
   * @param {Array<Array<string>>} results
   * @param {number} index
   * @returns {number}
   */
  getTotalValuesByIndex(results: Array<Array<string>>, index: number): number {
    return results.reduce((accumulator, currentValue) => {
      return accumulator + parseInt(currentValue[index]);
    }, 0);
  }

  /**
   * Find index in columns given a property
   * @param {Array<string>} columns
   * @param {string} property
   * @returns {number}
   */
  findIndexByProperty(columns: Array<string>, property: string) {
    return columns.findIndex(v => v === property)
  }

  /**
   * Get the shapes from every filter to show in the view (Currently we support OVAL and SQUARE)
   * @param {Array<ReportFilter>} showFilters
   * @returns {}
   */
  getShapesFromShowFilters(showFilters: Array<ReportFilter>) {
    let response = {};
    showFilters.forEach((v) => {
      response[v.label] = v.value;
    });
    return response;
  }

  /**
   * Init an object with sets in its properties based on column names
   * @param {Array<string>} columnNames
   * @returns {{}}
   */
  initFinalResult(columnNames: Array<string>) {
    let response = {};
    columnNames.forEach((val) => {
      response[val] = new Set();
    });
    return response;
  }

  /**
   * Filter main results
   * @param {Array<Array<string>>} results
   * @param {Array<string>} columnNames
   * @param {Array<string>} notFilteredColumnNames
   * @returns {Array<Array<string>>}
   */
  filterResults(results: Array<Array<string>>, columnNames: Array<string>, notFilteredColumnNames: Array<string>): Array<Array<string>> {
    let response: Array<Array<string>> = [];
    let auxArray: Array<string> = [];
    results.forEach((result, index) => {
      auxArray = [];
      result.forEach((val, indexResult) => {
        let magicFilter = notFilteredColumnNames[indexResult];
        if (columnNames.find((val) => val === magicFilter)) {
          auxArray.push(val);
        }
      });
      response[index] = auxArray;
    });
    return response;
  }

  /**
   * Init quantity object
   * @param {Array<Array<string>>} results
   * @param {Array<string>} columnNames
   * @param finalResult
   * @param {Array<string>} notFilteredColumnNames
   * @returns {{}}
   */
  initQuantities(results: Array<Array<string>>, columnNames: Array<string>, finalResult, notFilteredColumnNames: Array<string>) {
    let quantitiesObject = {};
    columnNames.forEach((key) => quantitiesObject[key] = {});
    Object.keys(finalResult).forEach((key) => {
      let indexKey = notFilteredColumnNames.findIndex((v) => v === key);
      finalResult[key].forEach((val) => {
        this.updateQuantities(quantitiesObject[key], val, results, indexKey);
      })
    });
    return quantitiesObject;
  }

  /**
   * Handle element selected if quantity is empty
   * @param self
   * @param properties
   */
  handleElementsIfQtyIsEmpty(self, properties) {
    Object.keys(properties).forEach((key) => {
      properties[key].forEach((property, i) => {
        if (i === 0) {
          property.selected = true;
          property.disabled = false;
        }
      })
    });
    setTimeout(function () {
      self.ShowAlertError(self.translate.instant('lookup.alerts.empty_results.title'), self.translate.instant('lookup.alerts.empty_results.message'), self.translate.instant('lookup.alerts.empty_results.ok'));
    }, 500)
  }

  changeSelectedProperty(newPropertyArray: Array<string>, properties, newArray) {
    newPropertyArray.forEach((val, index) => {
      properties[val][properties[val].findIndex((v: ItemFiler) => v.value === newArray[index])].selected = true;
      properties[val][properties[val].findIndex((v: ItemFiler) => v.value === newArray[index])].disabled = false;
    });
  }

  sortPropertyArray(valOfProperty, valOfQuantity) {
    return valOfProperty.sort((a, b) => valOfQuantity[b.value] - valOfQuantity[a.value])
  }

  /**
   * Clear variables
   */
  clearVariables() {
    this.filteredItem = [];
    this.sizeQuantities = {};
    this.finalResult = {};
    this.notFilteredColumnNames = [];
    this.columnNames = [];
    this.shapes = {};
    this.OVAL = LookupConstants.SHAPE_OVAL;
    this.SQUARE = LookupConstants.SHAPE_SQUARE;
    this.quantities = {};
    this.properties = {}
  }

  onChangeKeyValue(event) {
    let charPressed = event.charAt(event.length - 1);
    if (!charPressed) {
      charPressed = '';
    }
    let regExpression = new RegExp(VALIDATION_INPUT_TAG);
    if (!regExpression.test(<string>charPressed.toUpperCase())) {
      this.searchInputText = event.replace(charPressed, '');
      this.inputTagField.value = this.searchInputText;
    }
    else {
      this.searchInputText = event;
    }
    this.cdr.detectChanges();
  }

}

export class ItemFiler {
  constructor(public value: string,
              public selected: boolean,
              public disabled: boolean,
              public quantity?: boolean) {

  }
}



// WEBPACK FOOTER //
// ./src/pages/look-up/look-up.ts